<template>
  <v-input-number
    v-model="valueBackup"
    :precision="2"
    :placeholder="placeholder"
    :type="type"
    :is-show-suffix="isShowSuffix"
    :is-small-suffix="isSmallSuffix"
    :suffix-name="suffixName"
    :disabled="disabled"
    :is-plain="isPlain"
    :max="max"
    :min="min"
    @change="currentValue => $emit('change', currentValue)"
    @blur="currentValue => $emit('blur', currentValue)"
    :size="size"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'unsignedInt'
    },
    isShowSuffix: {
      type: Boolean,
      default: false,
    },
    isSmallSuffix: {
      type: Boolean,
      default: false,
    },
    suffixName: {
      type: String,
      default: '元'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isPlain: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: undefined,
    },
    min: {
      type: Number,
      default: undefined,
    },
    size: {
      type: String,
      default: 'medium',
    },
  },
  data: () => ({
    valueBackup: '',
  }),
  watch: {
    value(value) {
      if (value !== this.valueBackup) this.valueBackup = value;
    },
    valueBackup(valueBackup) {
      if (valueBackup !== this.value) this.$emit('input', valueBackup);
    },
  },
  beforeMount() {
    this.valueBackup = this.value;
  },
};
</script>
